import { render } from "./BusinessActivityDetails.vue?vue&type=template&id=dbc5d384"
import script from "./BusinessActivityDetails.vue?vue&type=script&lang=js"
export * from "./BusinessActivityDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__